import PropTypes from 'prop-types';
import React from 'react';
import { useIntl } from 'react-intl';

import { InventorySourcePropType } from './prop-types/inventory-source';

import { inventorySourceTypes, inventoryWarehouseTypes } from './constants';
import { messages } from '../messages';

const NameComponent = ({ children = null, name }) => {
  if (typeof children === 'function') {
    return children(name);
  }

  return <>{name}</>;
};

NameComponent.propTypes = {
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.func]),
  name: PropTypes.string.isRequired,
};

export const InventorySourceName = ({ children = null, inventorySource }) => {
  const intl = useIntl();
  if (inventorySource.inventorySourceType === inventorySourceTypes.none) {
    return <NameComponent name={intl.formatMessage(messages.noInventory)}>{children}</NameComponent>;
  }

  if (inventorySource.warehouseType === inventoryWarehouseTypes.aggregate) {
    return <NameComponent name={intl.formatMessage(messages.aggregateWarehouseName)}>{children}</NameComponent>;
  }

  return <NameComponent name={inventorySource.name}>{children}</NameComponent>;
};

InventorySourceName.propTypes = {
  children: PropTypes.func,
  inventorySource: InventorySourcePropType.isRequired,
};
